import { getDictApi, getTypeListApi } from '../api/bedManage';

export default {
  props: ['type', 'rowData', 'nursinghomeId'],
  data() {
    return {
      formData: {}, // 表单数据
      // 表单校验
      formRules: {
        // 连接符
        connector: [{ pattern: /^[-_\/@#&]$/, message: '只能输入-_/@#&', trigger: 'change' }],
        // 编号
        code: [
          { pattern: /^[a-zA-Z0-9]+|[a-zA-Z]+$/, message: '只能输入字母和数字', trigger: 'change' },
        ],
        // 数量
        num: [{ pattern: /^\+?[1-9][0-9]*$/, message: '只能输入正整数', trigger: 'change' }],
      },
      dirDict: [], // 朝向
      bedTypes: [], // 床位类型
      nurseTypeDict: [], // 护理类型
    };
  },
  async created() {
    // 获取多种下拉框数据
    await Promise.all([
      getDictApi({ code: 'nursing_toward_type' }),
      getTypeListApi({
        nursinghomeId: this.nursinghomeId,
      }),
      getDictApi({ code: 'nursing_type' }),
    ]).then((resArr) => {
      this.dirDict = resArr[0].data;
      this.bedTypes = resArr[1].data;
      this.nurseTypeDict = resArr[2].data;
    });
  },
  methods: {
    /* 保存 */
    doSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let fn = this.type == 'add' ? this.addApi : this.updateApi;
          fn(this.formData, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
    /* 清除单个表单项的校验提示 */
    clearValidate(prop) {
      this.$refs.formRef.clearValidate(prop);
    },
  },
};
